import { CarouselButtons, Stack, XStack, useCarousel } from '@my/ui'
import { BrandTabsProps } from './brand-tabs.props'
import { BrandTabItem } from './brand-tab-item'

export const BrandTabs = ({ items, imagePriority }: BrandTabsProps) => {
  const carousel = useCarousel()

  return (
    <Stack
      className="overflow-x-hidden"
      position="relative"
      w="100%"
      py="$3"
      my="$-3"
      ref={carousel.emblaRef as any}
    >
      <XStack height="auto" alignItems="stretch">
        {items.map((item) => (
          <Stack
            key={item.id}
            minWidth={0}
            flexGrow={0}
            flexShrink={0}
            mr="$3.5"
            $gtXs={{
              w: 200,
            }}
          >
            <BrandTabItem {...item} imagePriority={imagePriority} />
          </Stack>
        ))}
      </XStack>
      <CarouselButtons carousel={carousel} buttonProps={{ $xs: { display: 'none' } }} />
    </Stack>
  )
}
